import { localizationEnUsRequests, routerPageRequests } from "./requests";
import {
  localizationEnUsRequestCreate,
  routerPageRequestCreate,
} from "./request-create";
import {
  localizationEnUsRequestView,
  routerPageRequestView,
} from "./request-view";

export const localizationEnUsServices = {
  ...localizationEnUsRequests,
  ...localizationEnUsRequestCreate,
  ...localizationEnUsRequestView,
};

export const routersPageServices = [
  routerPageRequests,
  routerPageRequestCreate,
  routerPageRequestView,
];
